/**
 * FeaturedBackgroundVideo Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the FeaturedBackgroundVideo template.
 *
 * @namespace FeaturedBackgroundVideo
 */

import {register} from '../vendor/theme-scripts/theme-sections';
import {loadVideoVimeo} from '../features/load-video-vimeo';
import {loadVideoYT} from '../features/load-video-youtube';

register('featured-background-video', [loadVideoYT, loadVideoVimeo]);
